import React, { useState } from 'react';

import { Modal } from 'shared/presentation/components/atoms';
import { useMediaQuery } from 'shared/presentation/hooks';

import { FeedbackForm, Recommendation } from './components';
import { SessionFeedbackProvider, TFeedbackState } from './context';
import { useVerifyNpsSessionFeedback } from './hooks';

interface ISessionFeedbackModalProps {
  googleEvaluationLink?: string;
}

const SessionFeedbackModal: React.FC<ISessionFeedbackModalProps> = ({
  googleEvaluationLink,
}) => {
  const isMobile = useMediaQuery('md');
  const [state, setState] = useState<TFeedbackState>('NPS');

  const controller = useVerifyNpsSessionFeedback();

  if (!controller.session?.idHash || controller.session.hasNpsFeedback) {
    return null;
  }

  return (
    <SessionFeedbackProvider
      value={{
        state,
        setState,
        session: controller.session,
        googleEvaluationLink,
      }}
    >
      <Modal initialOpen align={isMobile ? 'bottom' : 'center'}>
        {state === 'RECOMMENDATION' ? <Recommendation /> : <FeedbackForm />}
      </Modal>
    </SessionFeedbackProvider>
  );
};

export default SessionFeedbackModal;
